import React from 'react';

import { Action, Actions, ActionBar } from '@gogame/components';
import { FullScreenToggler } from '@gogame/data-grid';
import { useChildComponent } from '@gogame/hooks-ts';
import { SearchField, useScreenTitle } from '@gogame/screens';

import { AnnotationFormCreate } from '../AnnotationForm';

export default () => {
  const [title] = useScreenTitle();
  const [childComponent, openChildComponent] = useChildComponent();

  const handleCreate = () => {
    openChildComponent(AnnotationFormCreate, {});
  };
  return (
    <>
      <ActionBar
        title={title}
        search={<SearchField tooltip={'Search by annotation text'} />}
        primaryActions={
          <Actions>
            <Action component={FullScreenToggler} />
            <Action
              border={true}
              button={true}
              add={true}
              iconContent={true}
              tooltip={'Add Annotation'}
              variant={'outlined'}
              onClick={handleCreate}
            />
          </Actions>
        }
      />
      {childComponent}
    </>
  );
};
